import styles from './styles.scss'

export default `<ul class="${styles.list}" data-multiplayer-items>
  <% playList.forEach(function (record) { %>
  <li class="${styles.item}" data-id="<%= record.id %>">
    <div class="${styles.itemThumbnail}">
      <img src="<%- record.preview %>" />
      <div class="${styles.itemDuration}"><%= record.duration %></div>
    </div>
    <div class="${styles.itemCaption}"><%- record.name %></div>
  </li>
  <% }) %>
</ul>
<div class="${styles.arrow} ${styles.leftArrow}" data-multiplayer-prev>
  <svg class="${styles.arrowIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M0 20V0m20 0v20m-7.88-3.82L6.65 10.7a1 1 0 0 1 0-1.42l5.47-5.47a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7L8.06 10l5.12 5.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0"/>
  </svg>
</div>
<div class="${styles.arrow} ${styles.rightArrow}" data-multiplayer-next>
  <svg class="${styles.arrowIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M0 20V0m20 0v20M7.18 16.18l-.36-.36a.5.5 0 0 1 0-.7L11.94 10 6.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5.47 5.47a1 1 0 0 1 0 1.42l-5.47 5.47a.5.5 0 0 1-.7 0"/>
  </svg>
</div>`
